import React, { Component } from 'react';
import {ChartGraphVerticalAxis, ChartTestGraph, ChartGraphHorizontalAxis} from "./ChartGraph";
import { SimpleVerticalSplitPane } from './SimpleSplitPane';
import { ChartZoomDirection } from './ChartAxisDirection';
import ChartGraphLinker from './ChartGraphLinker';
import * as d3 from 'd3';
import './ChartWidget.css';
import { AvailableTimeFrames } from './ChartTimeFrames';



function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

class ChartWidget extends Component {

    constructor(props) {
        super(props)
        this.wrapperRef = React.createRef();
        this.refOne = React.createRef();
        this.refTwo = React.createRef();
        this.refThree = React.createRef();
        this.refFour = React.createRef();
        this.refFive = React.createRef();

        this.scaleLockRef = React.createRef();
        this.scaleIsLocked = false



    }

    handleResize = () => {

        const newTransform = this.refOne.current.handleResize()
        this.refTwo.current.handleResize()
        this.refThree.current.handleResize()
        this.refFour.current.handleResize()
        this.refFive.current.handleResize()

        this.linker.adjustAfterResize(newTransform, this.refOne.current)
        this.linker.adjustAfterResize(newTransform, this.refThree.current)
    }

    handleSplitPaneResize = (indexOne, indexTwo) => {
        this.handleResize()
    }

    handleSplitPaneResizeEnd = (indexOne, indexTwo) => {

    }

    handleWindowResizeDebounced = debounce(() => {
        this.handleWindowResize()
    }, 10);

    handleWindowResize = () => {
        this.handleResize()
    }

    handleZoom = (event, zoomID, rowID, sourceZoomDirection) => {
        this.linker.handleZoomTransform(event, zoomID, true)
    }

    handlePrimaryZoom = (before, after) => {
        this.props.onZoomPrimaryChart(before, after, this.props.chartWidgetID)
    }

    handleLinkedPrimaryZoom = (before, after, chartSourceID) => {
        this.linker.handleDeltaZoomFromOtherWidget(before, after)
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.handleWindowResize)
    }

    componentDidUpdate() {
        console.log("i did update (ChartWidget)")
    }

    componentDidMount = () => {

        window.addEventListener("resize", this.handleWindowResizeDebounced)
        
        this.linker = new ChartGraphLinker(
            {graph: this.refOne.current, zoomID: "main top"},
            {graph: this.refFive.current, zoomID: "horizontal axis bottom"},
            {graph: this.refTwo.current, zoomID: "axis top"},
            {graph: this.refThree.current, zoomID: "main bottom"},
            {graph: this.refFour.current, zoomID: "axis bottom"},
            (before, after) => { this.handlePrimaryZoom(before, after) }
        )

        this.ohlcv = []
        const parseDate = d3.timeParse("%Y-%m-%d %I-%p");
        d3.csv("/assets/data/temp/Bitfinex_BTCUSD_1h.csv", (data) => {
            data.date = parseDate(data.Date); // returns a Date
            this.ohlcv.push(data)
        }).then(data => {
            this.refOne.current.databind(this.ohlcv)
        })

        this.handleSetTimeFrame("4h")
    }

    handleToggleLockScale = () => {
        this.scaleIsLocked = !this.scaleIsLocked
        this.scaleLockRef.current.classList.toggle('locked');
        this.linker.setLocked(this.scaleIsLocked)

        this.refOne.current.handleToggleLockScaleRatio(this.scaleIsLocked)
        this.refTwo.current.handleToggleLockScaleRatio(this.scaleIsLocked)
        this.refThree.current.handleToggleLockScaleRatio(this.scaleIsLocked)
        this.refFour.current.handleToggleLockScaleRatio(this.scaleIsLocked)
        this.refFive.current.handleToggleLockScaleRatio(this.scaleIsLocked)
    }

    handleSetTimeFrame = (key) => {
        this.refOne.current.setTimeFrame(key)
        Object.keys(this.buttonRefs).forEach((objKey) => {
            this.buttonRefs[objKey].current.classList.remove("selected");
        });
        this.buttonRefs[key].current.classList.add("selected");
    }


    render() {
        const mindate = new Date(2017,10,9)
        const maxdate = new Date()
        const verticalAxisWidth = 75
        const horizontalAxisHeight = 40
        const chartData = {domainX: [mindate, maxdate], domainY: [-10000, 100000]}
        const chartDataIndicator = {domainX: [mindate, maxdate], domainY: [0, 100]}
        const chartRenderProps = {scaleFuncX: d3.scaleTime, scaleFuncY: d3.scaleLinear}

        this.buttonRefs = {}
        const listItems = AvailableTimeFrames.map((frame) => {
            const r = React.createRef()
            this.buttonRefs[frame.key] = r
            return <li key={frame.key} ref={r} onClick={() => {this.handleSetTimeFrame(frame.key)}}>{frame.key}</li>
        });
        
        return (
            <div className="chart-widget" onMouseMove={this.handleMouseMoved}>
                <div className="chart-widget--toolbar-top">
                    <ul className="chart-widget--toolbar-top--timeframes">
                    {listItems}
                    </ul>
                </div>
                <SimpleVerticalSplitPane onResize={this.handleSplitPaneResize} onResizeEnd={this.handleSplitPaneResizeEnd} cacheIdentifier="innerSplitPane">
                    <div className="chart-graph-row row-0">
                        <ChartTestGraph zoomID={"main top"} isPrimary={true} zoomDirection={ChartZoomDirection.XY} rowID={0} ref={this.refOne} onZoom={this.handleZoom} chartRenderProps={chartRenderProps} chartData={chartData}/>
                        <ChartGraphVerticalAxis zoomID={"axis top"} isPrimary={false} zoomDirection={ChartZoomDirection.Y} rowID={0} ref={this.refTwo} onZoom={this.handleZoom} chartRenderProps={chartRenderProps} chartData={chartData} data={{}} preferedSize={verticalAxisWidth} />
                    </div>
                    <div className="chart-graph-row row-1">
                        <ChartTestGraph zoomID={"main bottom"} isPrimary={false} zoomDirection={ChartZoomDirection.XY} rowID={1} ref={this.refThree} onZoom={this.handleZoom} chartRenderProps={chartRenderProps} chartData={chartDataIndicator}/>
                        <ChartGraphVerticalAxis zoomID={"axis bottom"} isPrimary={false} zoomDirection={ChartZoomDirection.Y} rowID={1} ref={this.refFour} onZoom={this.handleZoom} chartRenderProps={chartRenderProps} chartData={chartDataIndicator} data={"hans"} preferedSize={verticalAxisWidth} />
                    </div>
                </SimpleVerticalSplitPane>
                <div className="chart-horizontal-axis-container">
                    <ChartGraphHorizontalAxis zoomID={"horizontal axis bottom"} isPrimary={false} zoomDirection={ChartZoomDirection.X} rowID={2} ref={this.refFive} onZoom={this.handleZoom} chartRenderProps={chartRenderProps} chartData={chartData} data={"punks"} preferedSize={horizontalAxisHeight} />
                    <div className="chart-temp-spacer" style={{ width: verticalAxisWidth + "px", height: horizontalAxisHeight + "px" }}>
                        <div ref={this.scaleLockRef} className="toggle-btn lock-scale" onClick={this.handleToggleLockScale}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChartWidget;


// WEBPACK FOOTER //
// ./src/ChartWidget.js